function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
export var lowercaseKeys = function lowercaseKeys(obj) {
  return Object.keys(obj).reduce(function (accumulator, key) {
    accumulator[key.toLowerCase()] = obj[key];
    return accumulator;
  }, {});
};
export var getOfflineUserData = function getOfflineUserData() {
  var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var offlineUserData;
  if (localStorage.getItem('offlineUserData')) {
    offlineUserData = JSON.parse(localStorage.getItem('offlineUserData'));
  }
  if (format) {
    return offlineUserData && offlineUserData.entrega ? offlineUserData.entrega : null;
  } else {
    return offlineUserData;
  }
};
export var getOfflineUserDataEmail = function getOfflineUserDataEmail() {
  var _getOfflineUserData;
  var userEmail = (_getOfflineUserData = getOfflineUserData(false)) === null || _getOfflineUserData === void 0 ? void 0 : _getOfflineUserData.email;
  return !!userEmail ? userEmail : null;
};
export var getOfflineWeatherData = function getOfflineWeatherData() {
  var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var offlineWeatherData;
  if (localStorage.getItem('offlineWeatherData')) {
    offlineWeatherData = JSON.parse(localStorage.getItem('offlineWeatherData'));
  }
  if (format) {
    return offlineWeatherData && offlineWeatherData.cookie ? offlineWeatherData.cookie : null;
  } else {
    return offlineWeatherData;
  }
};
export var getUserAddress = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(url, user) {
    var userData, addressData, offlineUserData;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          if (!(user !== null && user !== void 0 && user.isLogged)) {
            _context2.n = 2;
            break;
          }
          _context2.n = 1;
          return fetch("".concat(url, "/user-address-location")).then(/*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(response) {
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    if (!response.ok) {
                      _context.n = 2;
                      break;
                    }
                    _context.n = 1;
                    return response.json();
                  case 1:
                    userData = _context.v;
                    userData.forEach(function (element) {
                      if (element.lastSelected) {
                        addressData = {
                          City: element.city,
                          Country: element.country,
                          Department: null,
                          State: element.state,
                          ZipCode: element.zipCode,
                          Latitude: element.latitude,
                          Longitude: element.longitude
                        };
                      }
                    });
                    if (!addressData) {
                      userData.forEach(function (element) {
                        if (element.isDefault) {
                          addressData = {
                            City: element.city,
                            Country: element.country,
                            Department: null,
                            State: element.state,
                            ZipCode: element.zipCode,
                            Latitude: element.latitude,
                            Longitude: element.longitude
                          };
                        }
                      });
                    }
                    if (!addressData) {
                      addressData = getOfflineUserData();
                      addressData.userAddressWasEmpty = true;
                    } else {
                      // se actualiza el localStorage con los datos del usuario
                      updateOfflineUserData(addressData);
                    }
                    _context.n = 3;
                    break;
                  case 2:
                    addressData = getOfflineUserData();
                  case 3:
                    return _context.a(2, addressData);
                }
              }, _callee);
            }));
            return function (_x3) {
              return _ref2.apply(this, arguments);
            };
          }())["catch"](function (e) {
            addressData = getOfflineUserData();
            return addressData;
          });
        case 1:
          return _context2.a(2, _context2.v);
        case 2:
          offlineUserData = getOfflineUserData();
          if (offlineUserData) {
            addressData = offlineUserData;
          }
          return _context2.a(2, addressData);
        case 3:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return function getUserAddress(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var setUserAddress = function setUserAddress(isOffline, addressData, url) {
  var apiType = isOffline ? '-offline' : '';
  var payload = {
    country: addressData.Country,
    state: addressData.State,
    city: addressData.City,
    latitude: addressData.Latitude,
    longitude: addressData.Longitude,
    zipcode: addressData.ZipCode
  };
  if (isOffline && !!getOfflineUserDataEmail()) {
    payload.email = getOfflineUserDataEmail();
  }
  var parsedPayload = JSON.stringify(payload);
  fetch("".concat(url, "/user-address-location").concat(apiType), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: parsedPayload
  }).then(function () {})["catch"](function (e) {
    console.log('ERROR', e);
  });
};
export var confirmAddress = function confirmAddress() {
  localStorage.setItem('addressConfirmed', 'true');
};
export var isAddressConfirmed = function isAddressConfirmed() {
  return localStorage.getItem('addressConfirmed');
};
export var updateOfflineUserData = function updateOfflineUserData(newOfflineUserData) {
  var offlineUserData = getOfflineUserData(false);
  if (!offlineUserData) {
    localStorage.setItem('offlineUserData', JSON.stringify({
      entrega: newOfflineUserData
    }));
  } else {
    offlineUserData.entrega = newOfflineUserData;
    localStorage.setItem('offlineUserData', JSON.stringify(offlineUserData));
  }
  return getOfflineUserData();
};
export var updateOfflineUserDataWeather = function updateOfflineUserDataWeather(newOfflineWeatherData, type) {
  var offlineWeatherData = getOfflineWeatherData(false);
  if (!offlineWeatherData) {
    type === 'cookie' ? localStorage.setItem('offlineWeatherData', JSON.stringify({
      cookie: newOfflineWeatherData
    })) : localStorage.setItem('offlineWeatherData', JSON.stringify({
      saved: newOfflineWeatherData
    }));
  } else {
    type === 'cookie' ? offlineWeatherData.cookie = newOfflineWeatherData : offlineWeatherData.saved = newOfflineWeatherData;
    localStorage.setItem('offlineWeatherData', JSON.stringify(offlineWeatherData));
  }
  return getOfflineWeatherData();
};
export var getAddressByCoordinates = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref3) {
    var apiGateway, latitude, longitude, country, payload, requestOptions, response, data, userLocation;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          apiGateway = _ref3.apiGateway, latitude = _ref3.latitude, longitude = _ref3.longitude, country = _ref3.country;
          payload = {
            latitud: latitude,
            longitud: longitude,
            countryCode: country,
            onlyCity: true,
            validateDistance: false
          };
          requestOptions = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          };
          _context3.n = 1;
          return fetch("".concat(apiGateway, "/location/reversegeocode"), requestOptions);
        case 1:
          response = _context3.v;
          _context3.n = 2;
          return response.json();
        case 2:
          data = _context3.v;
          userLocation = {
            City: data.cityName || null,
            Country: data.country || null,
            Department: data.departmentName || null,
            State: data.provinceName || null,
            ZipCode: data.postalCode || null,
            Latitude: latitude,
            Longitude: longitude
          };
          return _context3.a(2, userLocation);
      }
    }, _callee3);
  }));
  return function getAddressByCoordinates(_x4) {
    return _ref4.apply(this, arguments);
  };
}();